var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSymptoms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#F97316",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.999 9.875C16.3873 9.875 16.7455 10.0801 16.9423 10.4164L22.8486 20.4789C23.0482 20.818 23.0482 21.2363 22.8541 21.5754C22.6599 21.9145 22.2963 22.125 21.9052 22.125H10.0927C9.70173 22.125 9.33805 21.9145 9.14391 21.5754C8.94977 21.2363 8.95251 20.8152 9.14938 20.4789L15.0556 10.4164C15.2525 10.0801 15.6107 9.875 15.999 9.875ZM15.999 13.375C15.6353 13.375 15.3427 13.6676 15.3427 14.0312V17.0938C15.3427 17.4574 15.6353 17.75 15.999 17.75Cnan nan 16.6552 17.4574 16.6552 17.0938V14.0312C16.6552 13.6676 16.3627 13.375 15.999 13.375ZM16.874 19.5C16.874 19.0171 16.4819 18.625 15.999 18.625C15.5161 18.625 15.124 19.0171 15.124 19.5C15.124 19.9829 15.5161 20.375 15.999 20.375C16.4819 20.375 16.874 19.9829 16.874 19.5Z",
    fill: "#F97316"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptoms);
export default __webpack_public_path__ + "static/media/Symptoms.7ddbc9e3de2548b413d7d49612fd874d.svg";
export { ForwardRef as ReactComponent };